import React from 'react';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { Data } from '../signup-data/DATA';
export const useNameFields = () => {
  const fields = [Data.FirstName, Data.LastName];
  const locale = getApplicationLocale();
  const orderedFields = locale === Locale.ja ? fields.reverse() : fields;
  const orderedFieldRefs = orderedFields.map(() => /*#__PURE__*/React.createRef());
  return {
    nameFields: orderedFields,
    nameFieldRefs: orderedFieldRefs
  };
};